<template>
<div class="contents_855">
  <header-bar active="profile"></header-bar>

  <div>
    <h1 class="title2">{{ $t('profile.customerInfo') }}</h1>
    <div class="contents_box mg20">
      <table class="form_tab">
        <tr>
          <th><p class="item2">{{ $t('profile.userId') }}</p></th>
          <td><p>{{ userIdDisplay }}</p></td>
        </tr>
        <tr>
          <th><p class="item2">{{ $t('profile.currentPlan') }}</p></th>
          <td><p>{{ currentPlanDisplay }}</p></td>
        </tr>
        <tr>
          <th><p class="item2">{{ $t('profile.nextPlan') }}</p></th>
          <td><p>{{ nextPlanDisplay }}</p></td>
        </tr>
      </table>
    </div>
    <ReadonlyViewIndividual
      v-if="!isCompany"
      :show-payment-method="false"
      :show-contact-guidance="true"
    />
    <ReadonlyViewCompany
      v-else
      :show-payment-method="false"
      :show-contact-guidance="true"
    />
    <div class="contents_box mg20">
      <table class="form_tab">
        <tr>
          <th><p class="item2">{{ $t('profile.invitationCode') }}</p></th>
          <td><p>{{ profileState.invitationCode }}</p></td>
        </tr>
      </table>
      <p class="submit_bx_l">
        <router-link :to="{name:'profile-edit'}" class="submit1 bg_green">
          {{ $t('profile.editInfo') }}
        </router-link>
      </p>
      <p class="submit_bx_r">
        <router-link :to="{name:'password-change'}" class="submit1 bg_green">
          {{ $t('profile.changePassword') }}
        </router-link>
      </p>
    </div>
  </div>
</div>
</template>

<script>
import { onMounted, reactive, computed, defineComponent, getCurrentInstance } from 'vue'
import { provideFilledUserState } from '@/components/lib/user/composables/useUserState'
import ReadonlyViewCompany from '@/components/lib/user/components/ReadonlyViewCompany.vue'
import ReadonlyViewIndividual from '@/components/lib/user/components/ReadonlyViewIndividual.vue'
import { provideMaster } from '@/composables/useMaster'
import { getNextPlanFromUserPlans } from '@/utils/userUtils'

export default defineComponent({
  components: { ReadonlyViewIndividual, ReadonlyViewCompany },
  setup() {
    const vue = getCurrentInstance().proxy
    const master = provideMaster()
    const userState = provideFilledUserState()

    const profileState = reactive({
      userId: -1,
      invitationCode: '',
      currentPlanId: '',
      currentPlanOption: '',
      nextPlanId: '',
      nextPlanOption: '',
    })
    const isCompany = computed(() => userState.is_company)
    const optionMap = computed(() => master.lovsMap.user_plan_option || {})

    onMounted(async() => {
      const token = vue.$store.getters['localStorage/serverToken']
      if (!token) {
        await vue.$router.push({name: 'login'})
        return
      }

      const me = await vue.$store.dispatch('user/getMe')
      profileState.userId = me.id
      profileState.invitationCode = me.invitation_code
      profileState.currentPlanId = me.user_plan?.plan_id || me.plan_id || ''
      profileState.currentPlanOption = me.user_plan?.user_plan_option ?? me.user_plan_option ?? ''

      const userPlans = Array.isArray(me?.user_plans) ? me.user_plans : []
      const nextPlan = getNextPlanFromUserPlans(
        userPlans,
        profileState.currentPlanId,
        profileState.currentPlanOption
      )
      profileState.nextPlanId = nextPlan?.plan_id || ''
      profileState.nextPlanOption = nextPlan?.user_plan_option ?? ''
    })

    const userIdDisplay = computed(() => {
      return profileState.userId < 0 ? '' : profileState.userId
    })
    const currentPlanDisplay = computed(() => {
      const plan = master.planMap[profileState.currentPlanId]
      if (!plan) return ''
      return plan.name + optionDisplay(profileState.currentPlanOption)
    })
    const nextPlanDisplay = computed(() => {
      if (!profileState.nextPlanId) return vue.$t('profile.nextPlanNone')
      const plan = master.planMap[profileState.nextPlanId]
      if (!plan) return ''
      return plan.name + optionDisplay(profileState.nextPlanOption)
    })

    function optionDisplay(option) {
      const obj = optionMap.value[option]
      return obj ? '/' + obj.val : ''
    }

    return {
      userState,
      userIdDisplay,
      profileState,
      currentPlanDisplay,
      nextPlanDisplay,
      isCompany,
    }
  },
  computed: {


  },
})
</script>

<style lang="scss" scoped>
.title {
  margin-bottom: 0;
}
</style>
